<template lang="pug">
v-app-bar.accent(fixed app)
    v-app-bar-nav-icon.hidden-lg-and-up(@click="toggle")
    v-toolbar-title {{ settings.name }} Admin
    v-spacer
    v-btn(icon, v-on:click="logout")
    v-icon mdi-logout
</template>

<script>
import {menuBus} from '../main';
export default {
  data() {
    return {
      settings: this.$dealer.user_settings,
    };
  },
  methods: {
    logout: function () {
      localStorage.removeItem("credentials");
      window.location.reload();
    },
    toggle: function() {
        menuBus.$emit('togglemenu')
    }
  }    
}
</script>